// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OBh2r","vertical":"styles_vertical__3Y_HX","primary":"styles_primary__f80IQ","secondary":"styles_secondary___owAI","horizontal":"styles_horizontal__Hb2Kf"};